import React, {PureComponent} from 'react';
import {View} from 'react-native';
import {Button, Text} from 'trpc-react-native-ui';

import {Icon} from '../../../components/common';
import {StyleSheet} from 'react-native';
import theme from '../../../theme-config';

class InternationalButton extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <Button
        style={[styles.container, {backgroundColor: this.props.color}]}
        onPress={this.props.onPress}>
        {this.props.iconName && (
          <Icon
            name={this.props.iconName}
            size={this.props.iconSize}
            color={theme.internationalIconColor}
            style={styles.iconStyle}
          />
        )}
        <View style={styles.textContainer}>
          <Text style={[styles.text, styles.title]}>{this.props.title}</Text>
          {this.props.additionalText && (
            <Text style={[styles.text, styles.additionalText]}>
              {this.props.additionalText}
            </Text>
          )}
        </View>
      </Button>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    container: {
      height: 155,
      flexDirection: 'row',
      borderRadius: 3,
      justifyContent: 'space-around',
      alignItems: 'center',
      marginBottom: 8,
    },
    iconStyle: {
      marginLeft: 25,
      flex: 3,
    },
    textContainer: {
      marginRight: 10,
      flex: 7,
    },
    text: {
      textAlign: 'center',
      fontWeight: '600',
      marginBottom: 5,
      color: theme.textOverColoredBackground,
    },
    title: {
      fontSize: 18,
      marginTop: 16,
    },
    additionalText: {
      marginLeft: 8,
      marginRight: 8,
      fontSize: 12,
    },
  });
}

type Props = {
  color: string,
  title: string,
  additionalText?: string,
  iconName?: string,
  iconSize?: number,
  onPress: Function,
};

export default InternationalButton;
